import React from 'react';
import { Container } from '../components/ui/Container';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Shield, Lock, Eye, Server, FileCheck, CheckCircle } from 'lucide-react';
export function TrustCenterPage() {
  const sections = [{
    title: 'Data Security',
    icon: Lock,
    content: ['SOC 2 Type II certified', '256-bit AES encryption at rest', 'TLS 1.3 encryption in transit', 'Regular security audits', 'Penetration testing']
  }, {
    title: 'Compliance',
    icon: FileCheck,
    content: ['GDPR compliant', 'CCPA compliant', 'Privacy Shield certified', 'ISO 27001 certified', 'Regular compliance reviews']
  }, {
    title: 'Access Control',
    icon: Shield,
    content: ['Role-based permissions', 'Two-factor authentication', 'SSO support (Enterprise)', 'Detailed audit logs', 'Session management']
  }, {
    title: 'Data Privacy',
    icon: Eye,
    content: ['Read-only Klaviyo access', 'No data sharing with third parties', 'Strict data retention policies', 'Right to deletion support', 'Data minimization principles']
  }, {
    title: 'Infrastructure',
    icon: Server,
    content: ['AWS hosting (US, EU regions)', '99.9% uptime SLA', 'Automated backups', 'DDoS protection', 'Disaster recovery plan']
  }];
  return <div className="bg-white" data-id="element-537">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-28 text-white" data-id="element-538">
        <Container data-id="element-539">
          <div className="text-center max-w-3xl mx-auto" data-id="element-540">
            <div className="inline-flex items-center justify-center p-3 bg-primary/20 rounded-xl mb-8" data-id="element-541">
              <Shield className="h-8 w-8 text-primary-400" data-id="element-542" />
            </div>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-543">
              Security & Compliance You Can Trust
            </h1>
            <p className="mt-6 text-xl text-gray-400" data-id="element-544">
              Enterprise-grade security protecting your data at every layer.
            </p>
          </div>
        </Container>
      </div>

      {/* Security Sections */}
      <div className="py-24" data-id="element-545">
        <Container data-id="element-546">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-547">
            {sections.map((section, index) => <Card key={index} className="h-full" data-id="element-548">
                <CardContent className="p-8" data-id="element-549">
                  <div className="flex items-center mb-6" data-id="element-550">
                    <div className="p-3 bg-gray-100 rounded-lg mr-4" data-id="element-551">
                      <section.icon className="h-6 w-6 text-gray-900" data-id="element-552" />
                    </div>
                    <h2 className="text-xl font-bold text-gray-900" data-id="element-553">
                      {section.title}
                    </h2>
                  </div>
                  <ul className="space-y-3" data-id="element-554">
                    {section.content.map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-555">
                        <CheckCircle className="h-5 w-5 text-success mr-3 flex-shrink-0 mt-0.5" data-id="element-556" />
                        <span data-id="element-557">{item}</span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>)}
          </div>

          {/* Certifications */}
          <div className="mt-24 text-center" data-id="element-558">
            <h3 className="text-lg font-semibold text-gray-900 mb-8" data-id="element-559">
              Certifications & Standards
            </h3>
            <div className="flex flex-wrap justify-center gap-8 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-560">
              {['SOC 2', 'GDPR', 'ISO 27001', 'CCPA', 'HIPAA'].map((cert, i) => <div key={i} className="flex items-center justify-center h-20 w-32 bg-gray-50 rounded-lg border border-gray-200 font-bold text-gray-400" data-id="element-561">
                    {cert}
                  </div>)}
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-562">
            <Button size="lg" variant="outline" data-id="element-563">
              Read Our Security Whitepaper
            </Button>
          </div>
        </Container>
      </div>
    </div>;
}